import {Component, Input, OnInit} from '@angular/core';
@Component({
    selector: 'app-block-text',
    templateUrl: './block-text.component.html',
    styleUrls: ['./block-text.component.scss'],
    standalone: false
})
export class BlockTextComponent implements OnInit {

    @Input() item: any;
    content: any;
    constructor() {}
    ngOnInit() {
        this.content = this.item.data.content;
    }
}
